import { MonitorIoTClass } from "@/services/backend/qpm/types/enums";

export class MonitorIoTClassUtil {
  private static descriptions: { [key in MonitorIoTClass]: string } = {
    [MonitorIoTClass.IoTGateway]: "Gateway",
    [MonitorIoTClass.IoTSim]: "Sim",
    [MonitorIoTClass.IoTPortal]: "Portal",
    [MonitorIoTClass.IoTSensor]: "Umgebungssensor",
    [MonitorIoTClass.IoTPestMonitor]: "Schädlingsmonitor",
    [MonitorIoTClass.IoTPestMonitorWithSim]:
      "Schädlingsmonitor integrierte SIM",
  };

  private static abbreviations: { [key in MonitorIoTClass]: string } = {
    [MonitorIoTClass.IoTGateway]: "Gateway",
    [MonitorIoTClass.IoTSim]: "Sim",
    [MonitorIoTClass.IoTPortal]: "Portal",
    [MonitorIoTClass.IoTSensor]: "Sensor",
    [MonitorIoTClass.IoTPestMonitor]: "Monitor",
    [MonitorIoTClass.IoTPestMonitorWithSim]: "Monitor",
  };

  static toString(type: MonitorIoTClass): string {
    return this.abbreviations[type];
  }

  static toLongString(type: MonitorIoTClass): string {
    return this.descriptions[type] || "Unknown";
  }
}
